import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {

  return [
    ColumnsFactory.TextColumn("Usuario", "nombre"),
    ColumnsFactory.TextColumn("Sociedad", "sociedad"),
    ColumnsFactory.TextColumn("Rol", "rol")
  ];
};
